import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useUser } from "../../context/UserContext";
import { hasUnidadeSelected } from "../../utils/session";
import { rotaLiberada, tipoDaLicenca } from "../../utils/licenca";

/**
 * Guard de rota.
 *
 * Só libera a tela quando o UserContext confirma a sessão (token válido +
 * perfil aceito pela API). Enquanto a verificação está em andamento mostra um
 * loader — nunca o conteúdo protegido.
 *
 * Confirmada a sessão, ainda filtra o que a licença da distribuidora contratou:
 * perfil que não carregou conta como licença completa, porque quem barra de
 * fato é a API e travar a interface por erro de rede deixaria o usuário sem
 * app nenhum.
 */
export default function RequireAuth({ children, requireUnidade = false }) {
	const { user, authStatus } = useUser();
	const location = useLocation();

	if (authStatus === "checking") {
		return (
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					minHeight: "100vh",
				}}
			>
				<CircularProgress />
			</Box>
		);
	}

	if (authStatus !== "authenticated") {
		return <Navigate to="/" replace />;
	}

	if (requireUnidade && !hasUnidadeSelected()) {
		return <Navigate to="/distribuidora/cadastro" replace />;
	}

	if (!rotaLiberada(location.pathname, tipoDaLicenca(user))) {
		return <Navigate to="/home" replace />;
	}

	return children;
}
